function Footer() {
  return (
    <div id="footer" className="flex items-center py-2 sm:py-4">
      <div className="pl-12">
        <a href="https://github.com/hye-kim">
          <i className="fab fa-github text-white text-4xl sm:text-5xl"></i>
        </a>
      </div>
    </div>
  );
}

export default Footer;
